import { useState } from "react";
import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

const stats = [
  { value: "10万+", label: "海量漫画资源", icon: "ri-book-2-fill" },
  { value: "5000万+", label: "累计读者", icon: "ri-user-heart-fill" },
  { value: "每日更新", label: "实时追更", icon: "ri-flashlight-fill" },
  { value: "9.5+", label: "读者平均评分", icon: "ri-star-smile-fill" },
];

const values = [
  { title: "品质阅读", desc: "精心挑选优质漫画，带来高清流畅的阅读体验。", icon: "ri-vip-crown-fill" },
  { title: "免费畅读", desc: "坚持漫画全集下拉式免费阅读，让每个人都能享受阅读。", icon: "ri-gift-fill" },
  { title: "实时更新", desc: "紧跟连载进度，第一时间同步最新章节内容。", icon: "ri-time-fill" },
  { title: "尊重版权", desc: "尊重每一位创作者，积极维护版权与原创价值。", icon: "ri-shield-check-fill" },
];

const formUrl = "https://readdy.ai/api/form/d9vupto3256a3o8koo50";

export default function AboutPage() {
  const [status, setStatus] = useState<"idle" | "loading" | "success" | "error">("idle");
  const [formError, setFormError] = useState("");
  const [formOk, setFormOk] = useState("");

  async function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
    const form = e.currentTarget;
    const data = new FormData(form);
    const honeypot = (data.get("company_alt") as string) || "";

    const payload = new FormData();
    for (const [k, v] of data.entries()) {
      if (k === "company_alt") continue;
      payload.append(k, v);
    }

    if (honeypot.trim() !== "") {
      setFormOk("感谢你的留言，我们会尽快与你联系！");
      setFormError("");
      setStatus("success");
      form.reset();
      return;
    }

    setStatus("loading");
    setFormOk("");
    setFormError("");
    try {
      const res = await fetch(formUrl, { method: "POST", body: payload });
      const responseText = await res.text();
      let parsed: { code?: string; message?: string; meta?: { message?: string; detail?: string } } | null = null;
      try {
        parsed = responseText ? JSON.parse(responseText) : null;
      } catch {
        parsed = null;
      }
      const serverMsg =
        parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText;
      const ok = res.ok && parsed?.code === "OK";
      if (ok) {
        setFormOk(serverMsg && serverMsg !== "" ? serverMsg : "提交成功，我们会尽快与你联系！");
        setStatus("success");
        form.reset();
      } else {
        const show = (serverMsg && serverMsg.trim() !== "" && !/spam/i.test(serverMsg))
          ? serverMsg
          : "提交失败，请稍后重试。";
        setFormError(show);
        setStatus("error");
      }
    } catch {
      setFormError("网络异常，提交失败，请稍后重试。");
      setStatus("error");
    }
  }

  return (
    <div className="w-full mx-auto px-4 md:px-6 py-6 md:py-8">
      <div className="max-w-7xl mx-auto">
        <nav className="text-sm text-foreground-500 mb-6 flex flex-wrap items-center gap-1.5" aria-label="面包屑导航">
          <Link to="/" className="hover:text-primary-600 transition-colors">首页</Link>
          <i className="ri-arrow-right-s-line w-4 h-4 flex items-center justify-center" aria-hidden="true" />
          <span className="text-foreground-700">关于我们</span>
        </nav>

        <section className="relative w-full rounded-lg overflow-hidden h-[280px] md:h-[340px] mb-10 flex items-center justify-center" aria-label="关于36漫画网">
          <img
            src="https://readdy.ai/api/search-image?query=Artistic%20illustration%20of%20open%20books%20and%20floating%20comic%20bubbles%20in%20a%20warm%20cozy%20library%2C%20golden%20light%2C%20soft%20cream%20and%20orange%20tones%2C%20creative%20and%20welcoming%20atmosphere%2C%20stylized%20digital%20art&width=1600&height=800&seq=about-banner&orientation=landscape"
            alt="36漫画网 关于我们"
            title="36漫画网 品牌介绍"
            className="absolute inset-0 w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-primary-800/80 to-primary-900/70"></div>
          <div className="relative z-10 text-center px-4">
            <h1 className="font-heading text-3xl md:text-4xl text-background-50 mb-3">关于 36漫画网</h1>
            <p className="text-sm md:text-base text-background-100/90 max-w-2xl mx-auto leading-relaxed">
              专注漫画全集下拉式免费阅读的在线平台，为你带来便捷、流畅、高品质的中文漫画在线阅读体验。
            </p>
          </div>
        </section>

        <section className="mb-12">
          <h2 className="font-heading text-xl md:text-2xl text-foreground-900 mb-4">品牌介绍</h2>
          <div className="flex flex-col gap-4 text-sm md:text-base text-foreground-700 leading-relaxed">
            <p>
              36漫画网创立以来，始终致力于为用户提供优质、便捷、免费的中文漫画在线阅读服务。我们汇集了恋爱、校园、奇幻、都市、热血、悬疑等数十个热门分类的海量漫画资源，无论是脍炙人口的经典作品，还是备受期待的新番连载，你都能在这里找到。
            </p>
            <p>
              我们深知每一位读者的热爱与期待，因此始终坚持「漫画全集下拉式免费阅读」的产品理念。无需付费、无需注册，打开网页即可随时随地畅读，配合流畅的下拉式阅读交互，让你沉浸式享受每一部作品的魅力。
            </p>
            <p>
              同时，我们重视内容的品质与版权，与众多创作者和出版社建立合作，努力维护健康、良性的漫画阅读生态。未来，36漫画网将继续深耕内容与服务，把更多精彩漫画带给每一位热爱二次元的你。
            </p>
          </div>
        </section>

        <section className="grid grid-cols-2 lg:grid-cols-4 gap-3 md:gap-4 mb-12" aria-label="平台数据">
          {stats.map((s) => (
            <div key={s.label} className="rounded-lg bg-secondary-100 border border-secondary-200 px-4 py-6 text-center">
              <span className="w-12 h-12 mx-auto mb-3 rounded-full bg-secondary-500 text-background-50 flex items-center justify-center text-2xl">
                <i className={`${s.icon} w-6 h-6 flex items-center justify-center`} aria-hidden="true" />
              </span>
              <p className="font-heading text-2xl text-secondary-900">{s.value}</p>
              <p className="text-sm text-secondary-800 mt-1">{s.label}</p>
            </div>
          ))}
        </section>

        <section className="mb-12" aria-labelledby="value-title">
          <h2 id="value-title" className="font-heading text-xl md:text-2xl text-foreground-900 mb-6 text-center">我们的承诺</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
            {values.map((v) => (
              <div key={v.title} className="rounded-lg bg-background-100 border border-background-200/70 p-5 flex flex-col gap-3">
                <span className="w-11 h-11 rounded-lg bg-accent-100 text-accent-700 flex items-center justify-center text-xl">
                  <i className={`${v.icon} w-5 h-5 flex items-center justify-center`} aria-hidden="true" />
                </span>
                <h3 className="font-heading text-base text-foreground-900">{v.title}</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">{v.desc}</p>
              </div>
            ))}
          </div>
        </section>

        <section className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-12">
          <div className="rounded-lg bg-background-100 border border-background-200/70 p-6 md:p-8">
            <h2 className="font-heading text-xl md:text-2xl text-foreground-900 mb-4">联系方式</h2>
            <ul className="flex flex-col gap-4 text-sm text-foreground-700">
              <li className="flex items-center gap-3">
                <span className="w-10 h-10 rounded-md bg-secondary-100 text-secondary-700 flex items-center justify-center text-lg">
                  <i className="ri-mail-line w-5 h-5 flex items-center justify-center" aria-hidden="true" />
                </span>
                <div>
                  <p className="font-medium text-foreground-900">商务邮箱</p>
                  <p>service@36mang.com</p>
                </div>
              </li>
              <li className="flex items-center gap-3">
                <span className="w-10 h-10 rounded-md bg-secondary-100 text-secondary-700 flex items-center justify-center text-lg">
                  <i className="ri-wechat-line w-5 h-5 flex items-center justify-center" aria-hidden="true" />
                </span>
                <div>
                  <p className="font-medium text-foreground-900">官方公众号</p>
                  <p>36漫画网</p>
                </div>
              </li>
              <li className="flex items-center gap-3">
                <span className="w-10 h-10 rounded-md bg-secondary-100 text-secondary-700 flex items-center justify-center text-lg">
                  <i className="ri-phone-line w-5 h-5 flex items-center justify-center" aria-hidden="true" />
                </span>
                <div>
                  <p className="font-medium text-foreground-900">客服电话</p>
                  <p>400-888-0000（工作日 9:00 - 18:00）</p>
                </div>
              </li>
              <li className="flex items-center gap-3">
                <span className="w-10 h-10 rounded-md bg-secondary-100 text-secondary-700 flex items-center justify-center text-lg">
                  <i className="ri-map-pin-line w-5 h-5 flex items-center justify-center" aria-hidden="true" />
                </span>
                <div>
                  <p className="font-medium text-foreground-900">公司地址</p>
                  <p>北京市朝阳区建国路88号动漫产业园</p>
                </div>
              </li>
            </ul>
            <div className="mt-6">
              <h3 className="font-heading text-base text-foreground-900 mb-3">热门分类直达</h3>
              <div className="flex flex-wrap gap-2">
                {categories.map((c) => (
                  <Link key={c.slug} to={`/category/${c.slug}`} className="rounded-full bg-secondary-100 text-secondary-900 text-xs px-3 py-1.5 hover:bg-secondary-200 transition-colors">
                    {c.name}漫画
                  </Link>
                ))}
              </div>
            </div>
          </div>

          <div className="rounded-lg bg-background-100 border border-background-200/70 p-6 md:p-8">
            <h2 className="font-heading text-xl md:text-2xl text-foreground-900 mb-2">在线留言</h2>
            <p className="text-sm text-foreground-600 mb-5">欢迎留下你的建议、反馈或合作意向，我们会尽快回复。</p>
            <form id="contact-form" data-readdy-form="d9vupto3256a3o8koo50" onSubmit={handleSubmit} className="flex flex-col gap-4" aria-label="联系我们表单">
              <div className="hp-field" aria-hidden="true">
                <input type="text" name="company_alt" tabIndex={-1} autoComplete="off" readOnly aria-hidden="true" />
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div className="flex flex-col gap-1.5">
                  <label htmlFor="name" className="text-sm text-foreground-700">您的称呼</label>
                  <input id="name" name="name" type="text" required maxLength={50} placeholder="请输入您的称呼" className="rounded-md bg-background-50 border border-background-300 px-3 py-2.5 text-sm text-foreground-900 focus:outline-none focus:ring-2 focus:ring-primary-400 focus:border-transparent" />
                </div>
                <div className="flex flex-col gap-1.5">
                  <label htmlFor="email" className="text-sm text-foreground-700">电子邮箱</label>
                  <input id="email" name="email" type="email" required placeholder="you@example.com" className="rounded-md bg-background-50 border border-background-300 px-3 py-2.5 text-sm text-foreground-900 focus:outline-none focus:ring-2 focus:ring-primary-400 focus:border-transparent" />
                </div>
              </div>
              <div className="flex flex-col gap-1.5">
                <label htmlFor="subject" className="text-sm text-foreground-700">留言主题</label>
                <select id="subject" name="subject" required className="rounded-md bg-background-50 border border-background-300 px-3 py-2.5 text-sm text-foreground-900 focus:outline-none focus:ring-2 focus:ring-primary-400 focus:border-transparent cursor-pointer">
                  <option value="">请选择主题</option>
                  <option value="建议反馈">建议反馈</option>
                  <option value="版权合作">版权合作</option>
                  <option value="商务合作">商务合作</option>
                  <option value="其他">其他</option>
                </select>
              </div>
              <div className="flex flex-col gap-1.5">
                <label htmlFor="message" className="text-sm text-foreground-700">留言内容</label>
                <textarea id="message" name="message" required maxLength={500} rows={4} placeholder="请输入你的留言（500字以内）" className="rounded-md bg-background-50 border border-background-300 px-3 py-2.5 text-sm text-foreground-900 focus:outline-none focus:ring-2 focus:ring-primary-400 focus:border-transparent resize-none"></textarea>
                <span className="text-xs text-foreground-400">最多 500 字</span>
              </div>
              {formError && (
                <p role="alert" className="rounded-md bg-primary-100 text-primary-800 px-3 py-2 text-sm">{formError}</p>
              )}
              {formOk && (
                <p role="status" className="rounded-md bg-secondary-100 text-secondary-900 px-3 py-2 text-sm">{formOk}</p>
              )}
              <button
                type="submit"
                disabled={status === "loading"}
                className="inline-flex items-center justify-center gap-2 rounded-md bg-primary-500 text-background-50 text-sm md:text-base font-medium px-6 py-3 whitespace-nowrap hover:bg-primary-600 transition-colors disabled:opacity-60 disabled:cursor-not-allowed cursor-pointer"
              >
                {status === "loading" ? "提交中..." : "提交留言"}
                <i className="ri-send-plane-line w-5 h-5 flex items-center justify-center" aria-hidden="true" />
              </button>
            </form>
          </div>
        </section>
      </div>
    </div>
  );
}